import axios from 'axios';

// In production (Vercel), set REACT_APP_API_URL to your deployed backend URL
// e.g., https://coachconnect-backend.vercel.app/api
// In development, it falls back to localhost
const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cc_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cc_token');
      localStorage.removeItem('cc_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ─── Auth ────────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  sendVerification: (data) => api.post('/auth/send-verification', data),
  verifyAndRegister: (data) => api.post('/auth/verify-and-register', data),
  resendVerification: (data) => api.post('/auth/resend-verification', data),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// ─── Users / Profile ────────────────────────────────────────
export const userAPI = {
  updateProfile: (data) => api.put('/users/profile', data),
};

// ─── Coaches ────────────────────────────────────────────────
export const coachAPI = {
  search: (params) => api.get('/coaches', { params }),
  getById: (id) => api.get(`/coaches/${id}`),
  getAvailability: (id) => api.get(`/coaches/${id}/availability`),
  updateAvailability: (data) => api.put('/coaches/availability', data),
};

// ─── Bookings ───────────────────────────────────────────────
export const bookingAPI = {
  create: (data) => api.post('/bookings', data),
  getAll: (params) => api.get('/bookings', { params }),
  update: (id, data) => api.put(`/bookings/${id}`, data),
};

// ─── Reviews ────────────────────────────────────────────────
export const reviewAPI = {
  create: (data) => api.post('/reviews', data),
};

// ─── Dashboard ──────────────────────────────────────────────
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

// ─── Misc ───────────────────────────────────────────────────
export const miscAPI = {
  getExpertise: () => api.get('/expertise'),
  seedDB: () => api.post('/seed'),
  healthCheck: () => api.get('/health'),
};

export default api;
